import React from "react";

type SpaceAgentThinkingStateProps = {
    isLoading?: boolean;
    message?: string;
};

const SpaceAgentThinkingState = ({ 
    isLoading = true, 
    message = "Processing your request..." 
}: SpaceAgentThinkingStateProps) => {
    if (!isLoading) return null;

    return (
        <div className="flex items-center">
            {/* Thinking text with gradient and animation */}
            <p className="text-sm animate-pulse bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent font-medium">
                {message}
            </p>
        </div>
    );
};

export default SpaceAgentThinkingState;

